import { Store } from 'libx'
import JobEvent from 'domain/JobEvent'
import { action } from 'mobx'
import { task } from 'mobx-task'
import memoize from 'memoizee'
import autobind from 'autobind-decorator'
import { browserHistory } from 'react-router'
import { match } from 'utils/patternMatchUtil'
import links from 'misc/links'

@autobind
export default class EventStore extends Store {
  constructor () {
    super(...arguments)
    this.jobEvents = this.collection({
      model: JobEvent
    })
    this.fetchJobEvents = this.fetchJobEvents.wrap(fn => memoize(fn, { promise: true, length: 1 }))
    this.rootStore.api.jobEvents.on('created', this.onRemoteUpdate)
  }

  @action onRemoteUpdate (data) {
    const isNew = !this.jobEvents.get(data.id)
    const event = this.jobEvents.set(data)
    if (isNew) {
      const opts = this._getNotificationOpts(event)
      if (opts) {
        this.rootStore.desktopNotificationStore.show(opts)
      }
    }
  }

  @task fetchJobEvents (jobId) {
    return this.rootStore.api.jobEvents.find({ job: jobId }).then(action(this.jobEvents.set))
  }

  _getNotificationOpts (event) {
    const notifyOpts = {
      timeout: 20,
      onClick: () => browserHistory.push(links.projectDetails(event.jobId))
    }
    const job = event.job
    // Don't show notifications for events the current user initiated.
    if (event.triggeredBy === this.rootStore.authStore.user) {
      return null
    }

    return match(event.eventType, {
      UNCLAIMED: () => ({
        ...notifyOpts,
        title: `${job.name} transferred to pool`,
        body: `${event.triggeredBy.displayName} transferred the job to the pool.`,
        icon: event.triggeredBy.avatar
      }),
      CLAIMED: () => ({
        ...notifyOpts,
        title: `${job.name} has been assigned`,
        body: `${job.name} assigned to ${job.provider.displayName}.`,
        icon: job.provider.avatar
      }),
      UPDATED: () => ({
        ...notifyOpts,
        title: `${job.name} updated`,
        body: `${event.triggeredBy.displayName} updated the details of ${job.name}`,
        icon: event.triggeredBy.avatar
      }),
      AMENDED: () => ({
        ...notifyOpts,
        title: `${job.name} amended`,
        body: `${event.triggeredBy.displayName} amended ${job.name}`,
        icon: event.triggeredBy.avatar
      }),
      REOPENED: () => ({
        ...notifyOpts,
        title: `${job.name} reopened`,
        body: `${event.triggeredBy.displayName} reopened ${job.name}`,
        icon: event.triggeredBy.avatar
      }),
      TRANSFERRED: () => ({
        ...notifyOpts,
        title: `${job.name} transferred`,
        body: `${job.name} transferred to ${event.newProvider.displayName}`,
        icon: event.newProvider.avatar
      }),
      CLOSED: () => ({
        ...notifyOpts,
        title: `${job.name} was closed`,
        body: `${job.name} was closed by ${job.provider.displayName}.`,
        icon: job.provider.avatar
      }),
      [match.DEFAULT]: () => null
    })
  }
}



// WEBPACK FOOTER //
// ./src/client/store/EventStore.js